import React from 'react';
import { Fieldset } from 'react-redux-form';
import TextArea from 'components/Fields/TextArea';


const FormComments = () => (
  <Fieldset model=".properties">
    <TextArea
      model=".comment"
      label="Ajoutez un commentaire"
      placeholder="Utlisez ce champ si vous avez besoin d'apporter des précisions"
      errorMessages={{ lengthMax: { message: '1500 caractères maximum', rule: val => !val || val.length <= 1500 } }}
    />
  </Fieldset>
);

export default FormComments;



// WEBPACK FOOTER //
// ./src/components/Form/FormComments.js